/* acaciasupplies — motion.js (S39; motion v2, 11 oct 2026). Lo que
   motion.css no puede decidir solo. Diferido. Lo que tiene que estar antes
   del primer pintado —las clases mo, mo-enter y mo-draw en <html>, la vez
   por sesión del logotipo y el salto en las transiciones de vista— vive en
   `snippets/motion-boot.liquid`. El contrato entero, en `docs/motion.md`.

   Aquí solo se cambian ESTADOS (`data-motion-state`, `hidden`, `inert`); el
   movimiento es del CSS, dentro de `prefers-reduced-motion: no-preference`.
   Con `reduce` todo lo de aquí sigue funcionando y los cambios son secos: las
   esperas se miden en la transición que el CSS haya puesto, y sin
   transición valen 0.

   API: `window.acaciasupplies.motion`
     respond(button, text)   5 · el botón pasa a decir `text` («Added», la
                             confirmación); sin `text`, vuelve a su etiqueta
     fieldMsg(slot, text)    5 · enciende el error de campo en su hueco; sin
                             `text`, lo apaga
     open(el) / close(el)    6 · el panel (`data-motion~="drawer"`); las dos
                             devuelven una promesa que se cumple al terminar
     fold(el, open)          6 · abre o cierra un pliegue
     wait(el)                lo que dura la transición más larga de `el` y
                             de sus partes, en ms (0 con `reduce`)
   Y por delegación, sin que nadie llame a nada: los botones de los
   pliegues, la tira de Makers A–Z (`data-motion~="scroll"`) y el toque en
   la foto de una tarjeta o lámina con interior (`data-motion~="inside"`:
   primer toque, el interior; segundo, la ficha; fuera, el exterior). */
(function (w, d) {
  'use strict';

  var root = d.documentElement;
  var as = w.acaciasupplies = w.acaciasupplies || {};
  if (as.motion) return;

  var still = !w.matchMedia || !w.matchMedia('(prefers-reduced-motion: no-preference)').matches;

  /* ── 4. Entrada: lo de debajo del pliegue no se anima, y lo que ya entró
     se suelta de la animación. ─────────────────────────────────────────── */
  function settleSections() {
    if (!root.classList.contains('mo')) return;
    var fold = w.innerHeight || root.clientHeight;
    var sections = d.querySelectorAll('#main > .shopify-section');
    for (var i = 0; i < sections.length && i < 5; i++) {
      if (sections[i].getBoundingClientRect().top >= fold) sections[i].setAttribute('data-mo-still', '');
    }
    d.addEventListener('animationend', function (event) {
      if (event.animationName === 'mo-enter') event.target.setAttribute('data-mo-still', '');
    });
  }

  /* ── Esperas ─────────────────────────────────────────────────────────── */
  function ms(list) {
    return Math.max.apply(null, String(list || '0s').split(',').map(function (v) {
      v = v.trim();
      return v.slice(-2) === 'ms' ? parseFloat(v) : parseFloat(v) * 1000;
    }).concat(0)) || 0;
  }

  function wait(el) {
    var parts = [el].concat(Array.prototype.slice.call(el.querySelectorAll('[data-motion-part]')));
    return parts.reduce(function (most, part) {
      var cs = w.getComputedStyle(part);
      return Math.max(most, ms(cs.transitionDuration) + ms(cs.transitionDelay));
    }, 0);
  }

  function after(el, fn) {
    var t = wait(el);
    if (!t) { fn(); return; }
    setTimeout(fn, t + 34);
  }

  /* ── 5. Respuesta a una acción ───────────────────────────────────────── */
  function layers(button) {
    var label = button.querySelector(':scope > .m-respond__label');
    if (label) return { label: label, done: button.querySelector(':scope > .m-respond__done') };
    label = d.createElement('span');
    label.className = 'm-respond__label';
    while (button.firstChild) label.appendChild(button.firstChild);
    var done = d.createElement('span');
    done.className = 'm-respond__done';
    done.setAttribute('aria-hidden', 'true');
    button.append(label, done);
    return { label: label, done: done };
  }

  function respond(button, text) {
    if (!button) return;
    var fresh = !button.querySelector(':scope > .m-respond__label');
    var l = layers(button);
    /* Capas recién puestas: sin un estilo de partida no hay transición. */
    if (fresh) w.getComputedStyle(l.done).opacity;
    if (text) {
      l.done.textContent = text;
      button.setAttribute('data-motion-state', 'done');
    } else {
      button.removeAttribute('data-motion-state');
    }
  }

  function fieldMsg(slot, text) {
    if (!slot) return;
    var msg = slot.querySelector('[data-motion-msg]') || slot;
    if (text) {
      msg.textContent = text;
      slot.setAttribute('data-motion-state', 'on');
      return;
    }
    slot.removeAttribute('data-motion-state');
    after(slot, function () {
      if (slot.getAttribute('data-motion-state') !== 'on') msg.textContent = '';
    });
  }

  /* ── 6. Panel ────────────────────────────────────────────────────────── */
  function open(el) {
    var token = el.__motion = {};
    el.hidden = false;
    return new Promise(function (resolve) {
      /* Dos fotogramas: el primero pinta el estado cerrado (fuera de la
         pantalla), el segundo pone el abierto y el CSS lo lleva hasta allí. */
      w.requestAnimationFrame(function () {
        w.requestAnimationFrame(function () {
          if (el.__motion !== token) return resolve(false);
          el.setAttribute('data-motion-state', 'open');
          after(el, function () { resolve(el.__motion === token); });
        });
      });
    });
  }

  function close(el) {
    var token = el.__motion = {};
    el.removeAttribute('data-motion-state');
    return new Promise(function (resolve) {
      after(el, function () {
        if (el.__motion !== token) return resolve(false);
        el.hidden = true;
        resolve(true);
      });
    });
  }

  /* ── 6. Pliegue ──────────────────────────────────────────────────────── */
  function fold(el, isOpen) {
    var body = el.querySelector('[data-motion-part="body"]');
    var toggle = el.querySelector('[data-motion-toggle]');
    if (isOpen) el.removeAttribute('data-motion-state');
    else el.setAttribute('data-motion-state', 'closed');
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (body) body.inert = !isOpen;
  }

  function initFolds() {
    d.querySelectorAll('[data-motion~="fold"]').forEach(function (el) {
      var toggle = el.querySelector('[data-motion-toggle]');
      fold(el, toggle ? toggle.getAttribute('aria-expanded') === 'true' : true);
    });
  }

  /* ── 6. Makers A–Z: desplazamiento suave al grupo ────────────────────── */
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

  function destination(target) {
    var margin = parseFloat(w.getComputedStyle(target).scrollMarginTop) || 0;
    return Math.max(0, Math.min(w.scrollY + target.getBoundingClientRect().top - margin, root.scrollHeight - w.innerHeight));
  }

  function glide(target) {
    var from = w.scrollY;
    var to = destination(target);
    var dur = ms(w.getComputedStyle(root).getPropertyValue('--m-panel')) || 320;
    var t0 = null;
    function step(now) {
      if (t0 === null) t0 = now;
      var k = Math.min(1, (now - t0) / dur);
      w.scrollTo(0, from + (to - from) * easeOut(k));
      if (k < 1) w.requestAnimationFrame(step);
    }
    w.requestAnimationFrame(step);
    return dur;
  }

  function onScrollLink(event, link) {
    var id = decodeURIComponent(link.hash.slice(1));
    var target = id && d.getElementById(id);
    if (!target || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    var dur = still ? 0 : glide(target);
    if (still) w.scrollTo(0, destination(target));
    if (w.location.hash !== link.hash) w.history.pushState(null, '', link.hash);
    /* Como el ancla nativa: el teclado sigue desde el grupo. */
    setTimeout(function () {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, dur);
  }

  /* ── 7. La foto del interior, al tocarla ─────────────────────────────
     Toque doble (motion-closeout): el primer toque sobre la FOTO enseña el
     interior; el segundo, sobre la foto o donde sea de la tarjeta, sigue el
     enlace y abre la ficha. Tocar fuera devuelve el exterior. Lo que no es
     la foto —nombre, código, «Notify me →»— abre la ficha al primer toque.
     Una lámina sin enlace (la Fig. 01 de la ficha) no tiene adónde ir: ahí
     el segundo toque devuelve el exterior. Ratón y teclado (un clic de
     teclado trae `detail` 0) siguen el enlace siempre. */
  var lastPointer = 'mouse';

  function outside(target) {
    d.querySelectorAll('[data-motion~="inside"][data-motion-state="inside"]').forEach(function (host) {
      if (!host.contains(target)) host.removeAttribute('data-motion-state');
    });
  }

  function onInsideTap(event, host) {
    var layer = host.querySelector('.m-inside');
    if (!layer || !layer.parentElement.contains(event.target)) return;
    if (lastPointer === 'mouse' || event.detail === 0) return;
    var shown = host.getAttribute('data-motion-state') === 'inside';
    var link = event.target.closest('a[href]');
    /* Segundo toque con enlace: que siga. */
    if (shown && link) return;
    event.preventDefault();
    if (shown) host.removeAttribute('data-motion-state');
    else host.setAttribute('data-motion-state', 'inside');
  }

  /* ── Delegación ──────────────────────────────────────────────────────── */
  d.addEventListener('pointerdown', function (event) {
    lastPointer = event.pointerType || 'mouse';
    if (event.target && event.target.nodeType === 1) outside(event.target);
  }, true);

  d.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var toggle = t.closest('[data-motion~="fold"] [data-motion-toggle]');
    if (toggle) {
      var el = toggle.closest('[data-motion~="fold"]');
      fold(el, el.getAttribute('data-motion-state') === 'closed');
      return;
    }
    var link = t.closest('[data-motion~="scroll"] a[href^="#"]');
    if (link) { onScrollLink(event, link); return; }
    var host = t.closest('[data-motion~="inside"]');
    if (host) onInsideTap(event, host);
  });

  as.motion = { respond: respond, fieldMsg: fieldMsg, open: open, close: close, fold: fold, wait: wait };

  function ready() {
    settleSections();
    initFolds();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})(window, document);
